<template>
  <v-layout  row justify-center>
    <v-dialog   v-model="dialog" lazy fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">   
          <v-toolbar-title>{{dialogTitle}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <!-- <v-btn v-if="component.saveCallback" flat @click.native="saveCallback()"> -->
              <!-- <v-icon>save</v-icon>&nbsp;Save</v-btn> -->
            <!-- <v-btn flat class="v-btn-noinherit" @click.native="closeDialog()">
              <v-icon>close</v-icon>&nbsp;Cancel</v-btn> -->
          </v-toolbar-items>
        </v-toolbar>
        <component v-if="dialogCustomComponent" fullscreen class="fp-dialog" :is="dialogMainComponent"></component>
        <component v-else fullscreen class="fp-dialog" :is="component.component"></component>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { sync } from 'vuex-pathify'
export default {
  props: [ 'component' ],
  methods: {
    closeDialog () {
      // if (this.component.closeCallback) {
      //   this.component.closeCallback()
      // }
      this.dialog = false
    },
    // saveDialog () {
    //   if (this.component.saveCallback) {
    //     this.component.saveCallback()
    //   }
    //   this.dialog = false
    // }
  },
  computed: {
    dialogTitle: sync('dialogTitle'),
    dialog: sync('dialogOpen'),
    dialogCustomComponent: sync('dialogCustomComponent'),
    dialogMainComponent: sync('dialogMainComponent')
  }
}
</script>

<style scoped>
.v-btn-noinherit {
  height: 2rem !important;
}
.fp-dialog {
  min-height: 100%;
  /* height: 100%; */
  width: 100%;
  /* margin: 10px; */
  /* border: 1px solid white; */
}
</style>


